export default "__VITE_ASSET__BGw0iw0r__"